import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  allRoles() {
    return api.get(`/api/v1/role`);
  },
  allPermissions() {
    return api.get(`/api/v1/role/permissions?skip=0&take=500`);
  },
  createRole(data) {
    return api.post(`/api/v1/role`, data);
  },
  updateRole(data) {
    return api.put(`/api/v1/role/${data.id}`, { name: data.name });
  },
  deleteRole(id) {
    return api.delete(`/api/v1/role/${id}`);
  },
  assignPermissionToRole(data) {
    return api.put(`/api/v1/role/permissions/${data.id}`, {
      permissions: data.permissions,
    });
  },
  assignRoleToUser(data) {
    return api.put(`/api/v1/role/user-role`, data);
  },
  assignPermissionsToUser(data) {
    return api.put(`/api/v1/role/user-permission`, data);
  },
};
